import ParentBridge from './ParentBridge';
import IframeChildBridge from './IframeChildBridge';
import { ChannelMessage, ChannelNameSpace, IChannel } from '../ChannelMessage';

function isUrl(url: string) {
  return /^https?:\/\/([a-zA-Z0-9]+\.)+[a-zA-Z0-9]+/.test(url);
}

/**
 * 创建互动 iFrame 容器
 * @param containerId
 */
function createContainer({ containerId = '', iframeSrc = COMPS_URL }: IChannel) {
  // iframe 宽度被内容撑出解决参考：https://segmentfault.com/a/1190000016352028
  let src = iframeSrc;
  const debugRes = /dbgpath=([^&]+)/.exec(location.search);
  let debugPath = '';
  if (debugRes) {
    [, debugPath] = debugRes;
    const dbgpath = decodeURIComponent(debugPath);
    if (isUrl(dbgpath)) {
      src = dbgpath;
    }
  }

  // 是否打印出 CompsBridge 的 invoke 执行
  if (/([?&])invoke=(1|true)/.test(location.search)) {
    src = src.indexOf('?') === -1 ? `${src}?invoke=1` : `${src}&invoke=1`;
  }

  const template = `
      <div id="iv-iframe"
        style="position: absolute; height: 100%; top: 0; width:100%; overflow: auto; -webkit-overflow-scrolling: touch;">
        <iframe id="iv-iframe-wrap"
          frameborder="0" style="height: 100%; overflow: hidden; width: 1px; min-width: 100%; *width: 100%;" scrolling="no">
        </iframe>
      </div>`;
  const tempElement = document.createElement('div');
  tempElement.innerHTML = template.trim();
  const [uiElement] = tempElement.childNodes;
  const container = containerId ? document.getElementById(containerId) : document.body;
  container.appendChild(uiElement);
  container.style.zIndex = '-1000';
  const doms = ['iv-iframe', 'iv-iframe-wrap'].map((did) => {
    const dom = document.getElementById(did);
    dom.addEventListener('touchmove', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
    });
    return dom;
  });

  // 设置src
  const iframe = doms[1] as HTMLIFrameElement;
  iframe.src = src;

  return [container, iframe];
}

export function createParentBridge(param: IChannel) {
  const [iframeContainer, iframe] = createContainer(param);
  return new Promise((resolve) => {
    const bridge = new ParentBridge({ iframe, iframeContainer });
    bridge.init((data: ChannelMessage) => {
      const { ns, method } = data;
      if (ns === ChannelNameSpace.engine) {
        if (method === 'init') {
          resolve(bridge);
          return;
        }
      }
      return param.init(data);
    });
  });
}

export function createChildBridge() {
  return new IframeChildBridge();
}
